module.exports = __webpack_public_path__ + "static/media/joinYyGroup.7eb3f25e.jpg";